var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c(_vm.enter,{tag:"component",attrs:{"changes":_vm.changes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }